<script setup>
import { computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

const route = useRoute()

const store = useStore()
const project = computed(() => store.getters['project/current'])
const projectId = computed(() => parseInt(route.params.project_id))
const hideLayout = computed(() =>
  ['ProjectCreate', 'ProjectHome', 'ProjectMonitoring', 'ProjectAlerts', 'ProjectImagery', 'ProjectChat', 'CreateTemplate', 'EditTemplate'].includes(route.name) ||
  route.matched.some(r => r.name === 'ProjectSettings')
)

const resetSelected = () => {
  store.commit('project/SET_CURRENT', null)
  store.commit('search/REMOVE_PARAM', { key: 'project_id' })
}

onMounted(async () => {
  await store.dispatch('project/fetchProject', projectId.value)
})

onBeforeUnmount(() => {
  resetSelected()
})

watch(() => project.value, (value) => {
  if (value) {
    store.commit('project/SET_LAST_SELECTED', value)
  }
})

// Watch for route changes to fetch new project when project_id changes
watch(() => projectId.value, async (newProjectId, oldProjectId) => {
  if (newProjectId && newProjectId !== oldProjectId) {
    await store.dispatch('project/fetchProject', newProjectId)
  }
})
</script>

<template>
  <div v-if="!hideLayout">
    <div class="p-3" :key="projectId">
      <router-view></router-view>
    </div>
  </div>
  <router-view v-else></router-view>
</template>
